import { BlockType, TArticleBodyBlock } from '../types';
import { renderParagraph } from './renderParagraph';
import { renderQuote } from './renderQuote';
import { renderHeader } from './renderHeader';
import { renderTable } from './renderTable';
import { renderList } from './renderList';
import { renderCode } from './renderCode';
import { renderCloudinaryImage } from './renderCloudinaryImage';
import { THighlightBodyBlock } from '../../Highlight/types';

type TBlockRenderers = {
  [key: string]: (data: TArticleBodyBlock['data'], highlightData?: THighlightBodyBlock['data']) => JSX.Element | null;
};
export const blockRenderers: TBlockRenderers = {
  [BlockType.Paragraph]: renderParagraph,
  [BlockType.Quote]: renderQuote,
  [BlockType.Header]: renderHeader,
  [BlockType.Table]: renderTable,
  [BlockType.List]: renderList,
  [BlockType.Code]: renderCode,
  [BlockType.Image]: renderCloudinaryImage,
};
